export const ITADVISORS_PARTNER_FLOW_VARIATION = 'itadvisors';
